import { Type } from "class-transformer";
import { ValidateImageUpload } from "@/util/ValidationUtil";
import { RapidInspectionReqDto } from "@/dto/inspection/rapid/RapidInspectionReqDto.ts";
import { Id } from "@/dto/CommonDto.ts";
import User from "@/model/User.ts";
import { InspectionRapidStationDto } from "@/dto/inspection/rapid/InspectionRapidStationDto.ts";
import { ValidateNested } from "class-validator";
import { InspectionOtherCpoDto } from "@/dto/inspection/InspectionOtherCpoDto.ts";

export class RapidInspectionDto extends Id {
    @ValidateNested()
    @Type(() => RapidInspectionReqDto)
    req: RapidInspectionReqDto;

    /**
     * 충전소/충전기
     */
    @Type(() => Object)
    @ValidateImageUpload("충전소 및 주위 전경")
    OVERVIEW: File;

    @Type(() => Object)
    @ValidateImageUpload("외관점검1")
    APPEARANCE_CHECK1: File;

    @Type(() => Object)
    @ValidateImageUpload("외관점검2")
    APPEARANCE_CHECK2: File;

    @Type(() => Object)
    @ValidateImageUpload("계량기")
    POWER_METER: File;

    /**
     * 점검 사항
     */
    @Type(() => Object)
    @ValidateImageUpload("입력 전압")
    INPUT_VOLTAGE: File;

    @Type(() => Object)
    @ValidateImageUpload("접지 저항")
    GROUND_RESISTANCE: File;

    @Type(() => Object)
    @ValidateImageUpload("절연 저항")
    INSULATION_RESISTANCE: File;

    @Type(() => Object)
    @ValidateImageUpload("추가 참고 사진", false)
    INSPECT_REF: File;

    /**
     * 내부점검
     */
    @Type(() => Object)
    @ValidateImageUpload("내부 점검1")
    INTERNAL_CHECK1: File;

    @Type(() => Object)
    @ValidateImageUpload("내부 점검2")
    INTERNAL_CHECK2: File;

    @Type(() => Object)
    @ValidateImageUpload("추가 참고 사진", false)
    INTERNAL_REF1: File;

    @Type(() => Object)
    @ValidateImageUpload("추가 참고 사진", false)
    INTERNAL_REF2: File;

    /**
     * 작동상태 점검
     */
    @Type(() => Object)
    @ValidateImageUpload("작동상태 점검 1")
    OPERATE_REF1: File;

    @Type(() => Object)
    @ValidateImageUpload("작동상태 점검 2 (충전 속도)")
    OPERATE_REF2: File;

    @Type(() => Object)
    @ValidateImageUpload("작동상태 점검 3 (비상정지버튼)")
    OPERATE_REF3: File;

    @Type(() => Object)
    @ValidateImageUpload("추가 참고 사진", false)
    OPERATE_REF4: File;

    /**
     * 분전반/기타
     */
    @Type(() => Object)
    @ValidateImageUpload("분전반 외부")
    PANELEXT: File;

    @Type(() => Object)
    @ValidateImageUpload("분전반 내부")
    PANELINT: File;

    @Type(() => Object)
    @ValidateImageUpload("충전기 안내판")
    GUIDESIGN: File;

    @Type(() => Object)
    @ValidateImageUpload("전용 주차구역")
    PARKING: File;

    /**
     * Site
     */
    @Type(() => Object)
    @ValidateImageUpload("Site 1", false)
    SITE1: File;

    @Type(() => Object)
    @ValidateImageUpload("Site 2", false)
    SITE2: File;

    @Type(() => Object)
    @ValidateImageUpload("Site 3", false)
    SITE3: File;

    @Type(() => Object)
    @ValidateImageUpload("Site 4", false)
    SITE4: File;

    constructor(user: User, data?: RapidInspectionReqDto) {
        super();
        if (data) {
            this.req = data;
        } else {
            this.req = {
                inspectionRapidStationDto: new InspectionRapidStationDto(),
                inspectionRapidChargerList: [],
                inspectionImageList: [],
                inspectionOtherCpoList: [new InspectionOtherCpoDto()],
                inspectionOutline: {
                    inspectorId: user?.email,
                    inspectorName: user?.name,
                    stationId: null,
                    businessName: null,
                    inspectorCompany: null,
                    inspectorCellphoneNumber: user?.phone,
                    inspectDate: null,
                    temperature: null,
                    humidity: null,
                    siteManagerName: null,
                    siteManagerPhoneNumber: null,
                    siteEvCount: null,
                    isNotCorrect: null,
                    notCorrectDetail: null,
                    isCompleted: false,
                },
            };
        }
    }
}